export const SECONDS_LABEL_WINDOW_MS = 60_000;
const MINUTE_MS = 60_000;
const MINUTE_ALIGN_SLACK_MS = 50;

export function nextClockDelayMs(nowMs: number, lastUpdatedMs: number | null): number {
  const sinceRefresh = nowMs - (lastUpdatedMs ?? 0);
  if (sinceRefresh < SECONDS_LABEL_WINDOW_MS) return 1000;
  return MINUTE_MS - (nowMs % MINUTE_MS) + MINUTE_ALIGN_SLACK_MS;
}
